const state = {
  LockerTableSelectedRow: {}
};

// const getters = {
//   getSubmittedRate: () => {
//     return state.isRateSubmitted;
//   }
// };

const mutations = {
  changeIsRateSubmitted: (state, row) => {
    //console.log("changeIsRateSubmitted row", row)
    state.LockerTableSelectedRow = row;
    //console.log("changeIsRateSubmittedstate LockerTableSelectedRow: ",state.LockerTableSelectedRow)
  },
  ResetSelectedRow: (state) => {
    state.LockerTableSelectedRow = {};
  }
};
// const actions = {
//   setRateSubmitted: ({ commit }) => {
//     return new Promise(() => {
//       commit("changeIsRateSubmitted");
//     });
//   }
// };

export default {
  namespaced: true,
  state,
  //   getters,
  //   actions,
  mutations
};
